import script from "./KKeypad.vue?vue&type=script&setup=true&lang=ts"
export * from "./KKeypad.vue?vue&type=script&setup=true&lang=ts"

import "./KKeypad.vue?vue&type=style&index=0&id=24153420&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24153420"]])

export default __exports__